// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as ApiEndpoint$OrcaPaymentPage from "../Utilities/ApiEndpoint.bs.js";
import * as LoggerUtils$OrcaPaymentPage from "../Utilities/LoggerUtils.bs.js";
import * as PaymentSessionMethods$OrcaPaymentPage from "./PaymentSessionMethods.bs.js";
import * as UpdateIntentHelpersNew$OrcaPaymentPage from "./UpdateIntentHelpersNew.bs.js";

function make(options, publishableKey, profileId, sdkSessionId, logger, redirectionFlags, iframeRef, isTestModeOpt, isUpdateIntentInProgress, clientSecretRef, sdkAuthorizationRef, paymentMethodsDataPromise, customerPaymentMethodsDataPromise, sessionTokensDataPromise) {
  var isTestMode = isTestModeOpt !== undefined ? isTestModeOpt : false;
  var logger$1 = Core__Option.getOr(logger, LoggerUtils$OrcaPaymentPage.defaultLoggerConfig);
  var customPodUri = Core__Option.getOr(Core__Option.flatMap(Core__Option.flatMap(Core__JSON.Decode.object(options), (function (x) {
                  return x["customPodUri"];
                })), Core__JSON.Decode.string), "");
  var endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(publishableKey, undefined);
  var updateIntent = function (callback) {
    return UpdateIntentHelpersNew$OrcaPaymentPage.performUpdateIntent(isUpdateIntentInProgress, clientSecretRef, sdkAuthorizationRef, paymentMethodsDataPromise, customerPaymentMethodsDataPromise, sessionTokensDataPromise, iframeRef.contents, callback, publishableKey, profileId, sdkSessionId, endpoint, customPodUri, isTestMode, false, "hyper-preMountLoader-session-iframe", false);
  };
  return {
          getCustomerSavedPaymentMethods: (function () {
              return PaymentSessionMethods$OrcaPaymentPage.getCustomerSavedPaymentMethods(clientSecretRef, publishableKey, endpoint, logger$1, customPodUri, sdkAuthorizationRef, redirectionFlags, iframeRef, isUpdateIntentInProgress);
            }),
          updateIntent: updateIntent
        };
}

export {
  make ,
}
/* ApiEndpoint-OrcaPaymentPage Not a pure module */
